import { SOLANA_NETWORK } from "@solomon-apps/config";

/**
 * The one place a Solscan URL is built for this page.
 *
 * `https://solscan.io/account/${x}` is currently hand-written at 27 call
 * sites across `shared`, `main`, `mint`, `yaas-issuer` and `wu-poc`. The
 * Security tab renders ten or so addresses on its own, so it would have
 * been the 28th through 37th. This helper exists so that it is not.
 *
 * It belongs in `packages/shared/src/utils/`, next to `truncateAddress`,
 * with the existing call sites folded onto it. That move is deliberately
 * NOT done here: it touches files outside this change's scope. Treat this
 * as the extraction point, not the final home.
 *
 * The cluster is read from configuration rather than written into the
 * string. Every `main` environment is `mainnet-beta` today, and mainnet is
 * Solscan's default and takes no parameter, so only other clusters name
 * themselves. If a devnet deployment is ever added, a link that omitted
 * the parameter would resolve against mainnet and show an account that
 * does not exist, which on a security page reads as a wrong address rather
 * than a wrong link.
 */
export function solscanAccountUrl(address: string, network: string = SOLANA_NETWORK): string {
    return `https://solscan.io/account/${address}${clusterQuery(network)}`;
}

/** A mint's token page, where its authorities and extensions are listed. */
export function solscanTokenUrl(mint: string, network: string = SOLANA_NETWORK): string {
    return `https://solscan.io/token/${mint}${clusterQuery(network)}`;
}

function clusterQuery(network: string): string {
    const cluster = network.toLowerCase();
    return cluster === "mainnet" || cluster === "mainnet-beta" ? "" : `?cluster=${cluster}`;
}
